import { render, staticRenderFns } from "./ExpenseGroupFormDlg.vue?vue&type=template&id=57ba80e9&"
import script from "./ExpenseGroupFormDlg.vue?vue&type=script&lang=js&"
export * from "./ExpenseGroupFormDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports